import React from 'react'
import startCase from 'lodash/startCase'
import { colors } from 'theme'
import { Box, InputLabel, TextField, makeStyles } from '@material-ui/core'

const roundMapping = {
  xs: 4,
  sm: 8,
  md: 12,
}

export default ({
  children,
  disabled,
  name,
  error,
  variant = 'filled',
  label = startCase(name),
  placeholder = label,
  hiddenLabel,
  floatLabel,
  roundedLevel = 'xs',
  helper,
  ...props
}) => {
  const classes = useStyles()
  const helperText = error || helper || ''

  const radius = roundMapping[roundedLevel] || 0

  return (
    <Box>
      {floatLabel && (
        <InputLabel className={classes.inputLabel}>{label}</InputLabel>
      )}
      <TextField
        name={name}
        id={name}
        label={hiddenLabel || floatLabel ? undefined : label}
        hiddenLabel={hiddenLabel}
        placeholder={placeholder}
        fullWidth
        error={!!error}
        helperText={helperText}
        disabled={disabled}
        variant={variant}
        InputLabelProps={{ required: false }}
        radius={radius}
        {...props}
        className={classes.textInput}
      >
        {children}
      </TextField>
    </Box>
  )
}

const useStyles = makeStyles(theme => ({
  inputLabel: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: colors.gray400,
    marginBottom: theme.spacing(0.5),
  },
  textInput: {
    '& .MuiInputBase-root': {
      borderRadius: '8px',
      marginBottom: theme.spacing(2),
    },
  },
}))
